import React, { useState } from 'react'
import { DatePicker, Drawer } from 'antd'
import moment from 'moment'
import { useHistory, useParams } from 'react-router-dom'

import { useToggle, stringifyDate, useListData, presets } from '../../modules'

import Receive from '../reusable/receive'
import { useSelector } from 'react-redux'
import pluralize from 'pluralize'

const { RangePicker } = DatePicker

const RequestsHistory = ({ path = '/app/store' }) => {
    const [ranges, setRanges] = useState()

    const { id, store } = useParams()
    const { user } = useSelector(state => state.application)

    const [{ loading, error, fetch }, 
        { list: requests, data }, 
        { Paginate, page = 1, limit = 100 }
    ] = useListData('requestsByStore', ranges ? {
        item: id,
        store,
        from: ranges[0]?._d ?? null, 
        to: ranges[1]?._d ?? null,
    } : {
        item: id,
        store,
    }, { notify: true }, 'requests')

    const hst = useHistory()

    const [visible, toggleVisible] = useToggle(true)

    const close = () => {
        toggleVisible()
        setTimeout(() => hst.goBack(), 300)
    }

    const selectRange = range => {
        setRanges(range)
        fetch()
    }

    return (
        <Drawer
            closable
            maskClosable
            visible={visible}
            onClose={close}
            footer={
                <div className="w-full text-right">
                    <button onClick={ close } className="text-white mr-2 bg-gray-500 hover:bg-gray-600 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center">Close</button>
                </div>
            }
            width="40%">
            <header className="pb-4 border-b border-gray-100 flex justify-between items-center">
                <p className="font-extrabold text-3xl mb-0">Requests History</p>
            </header>
            <div className="grid grid-flow-col sm:auto-cols-max justify-end gap-2">
                <RangePicker value={ ranges } onChange={selectRange} ranges={ presets } />
            </div>
            <Receive
                error={error}
                loading={loading}
                progress>
                <ul className="list-none m-0 p-0 mt-3">
                    {
                        requests.map(rqs => {
                            let itm = rqs.requests.find(rq => rq.item._id === id)

                            return (
                                <li className="mb-2">
                                    <div className="flex items-center mb-1">
                                        <div className={`${ itm.issued ? 'bg-green-500' : itm.discarded ? 'bg-gray-600' : itm.returned ? 'bg-blue-500' : 'bg-yellow-500'} rounded-full h-4 w-4 border-gray-200 border-2 z-10`}>
                                        </div>
                                        <div className="flex-1 ml-4 font-medium">{ itm.issued ? `Issued ${itm.qtyIssued} ${pluralize(itm.item.issuedIn, itm.qtyIssued)}` : itm.discarded ? 'Discarded' : itm.returned ? 'Returned' : 'Pending'}</div>
                                    </div>
                                    <div className="ml-12">
                                        <p className="text-xs italic mb-0">{ `Requested ${itm.quantity} ${pluralize(itm.item.issuedIn, itm.quantity)}` }</p>
                                        <p className="mb-1 mt-0 text-md">Request from { rqs.store?.name ?? rqs.department } by { rqs.requestedBy?.name }</p>
                                        {stringifyDate(rqs?.date)}
                                    </div>
                                </li>
                            )
                        })
                    }
                </ul>
            </Receive>
            { Paginate }
        </Drawer>
    )
}

export default RequestsHistory